import { AppStore, shouldShowLoadingIndicator } from '@tom-ui/utils'
import { InternalAxiosRequestConfig } from 'axios'

export const onFulfilled = (appStore: AppStore) => {
  return (request: InternalAxiosRequestConfig<any>) => {
    if (
      !request.url ||
      shouldShowLoadingIndicator(window.location.pathname, new URL(request.url).pathname)
    ) {
      appStore.increaseLoadingCounter()
    }

    return request
  }
}

export const onRejected = (appStore: AppStore) => {
  return (error: any) => {
    if (
      !error.config?.url ||
      shouldShowLoadingIndicator(window.location.pathname, new URL(error.config?.url).pathname)
    ) {
      appStore.decreaseLoadingCounter()
    }

    return Promise.reject(error)
  }
}
